export default "https://cdn-static.gokick.com/assets/bd7d2df9c3fbba7be4a416b625ad3f88793f3763/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";